export const keys = <T extends string | number, K>(collection: { [key in T]: K }) =>
  Object.keys(collection) as T[];
